const TRANSFERT_LIST_KEYS = ['results', 'data', 'transferts', 'dossiers', 'demandes', 'items'];
const TRANSFERT_SIGNAL_KEYS = [
  'id',
  'numero_demande',
  'form_type',
  'status',
  'statut',
  'piece_identite',
  'lettre_transfert',
  'formulaire_transfert_signe',
  'type_demande',
  'categorie',
];

const normalizeDemandeRecord = (record) => {
  if (!record || typeof record !== 'object') {
    return record;
  }

  const data = record.data && typeof record.data === 'object' ? record.data : {};
  const typeDemande = record.type_demande || data.type_demande;
  const isOffice = typeDemande === 'transfert_office';

  return {
    ...data,
    ...record,
    ...data,
    id: data.id || record.id,
    demande_id: record.id,
    list_id: `${typeDemande || 'demande'}-${record.id || data.id}`,
    type_demande: typeDemande,
    categorie: record.categorie || data.categorie || data.form_type,
    form_type: data.form_type || record.form_type || (isOffice ? 'conjoint' : record.categorie),
    numero_demande: record.numero_demande || data.numero_demande,
    statut: record.statut || data.statut,
    status: record.status || data.status || record.statut || data.statut,
    date_demande: record.date || data.date_demande || data.date_creation,
    is_office_transfer: isOffice || data.is_office_transfer === true,
    raw_demande: record,
  };
};

export const normalizeTransferDossiers = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload.map(normalizeDemandeRecord);
  }

  if (typeof payload !== 'object') {
    return [];
  }

  for (const key of TRANSFERT_LIST_KEYS) {
    if (Array.isArray(payload[key])) {
      return payload[key].map(normalizeDemandeRecord);
    }
  }

  for (const key of TRANSFERT_LIST_KEYS) {
    if (payload[key] && typeof payload[key] === 'object') {
      const nestedDossiers = normalizeTransferDossiers(payload[key]);
      if (nestedDossiers.length > 0) {
        return nestedDossiers;
      }
    }
  }

  const looksLikeTransfert = TRANSFERT_SIGNAL_KEYS.some((key) => payload[key] !== undefined);
  return looksLikeTransfert ? [payload] : [];
};
